/*
 * Painting offer: the cart side of the shopper-facing surfaces.
 *
 * Liquid renders the side cart's offer card, its win moment, the line pills
 * and "Complete your set". CSS shows the arm on
 * <html data-offer-arm>. This script never draws or changes the arm and never
 * builds markup. It only:
 *   1. starts the win moment: when the painting count crosses a step upwards,
 *      the drawer shows the green win state for a few seconds, once per step
 *      per session. Never on page load, never on a removal;
 *   2. keeps the cart page in step with the drawer: the stamping engine
 *      changes prices after a change, and only the drawer re-renders for it.
 */
(function () {
  if (window.omdOfferCart) return;

  var html = document.documentElement;
  var WIN_MS = 4000;
  // A step crossed waits this long for its discount to land (the stamps are
  // written after the add) before it is let go without a win.
  var WIN_WAIT = 10000;
  var SHOWN_KEY = 'omd_offer_wins';
  var STATE_SOURCE = 'side-cart-drawer [data-offer-test-count]';

  function arm() {
    return html.getAttribute('data-offer-arm') || '';
  }

  function readState() {
    var node = document.querySelector(STATE_SOURCE);
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      if (typeof data.n !== 'number') return null;
      return {
        n: data.n,
        saving: Number(data.saving) || 0,
        stamped: Number(data.stamped) || 0,
        stamped30: Number(data.stamped30) || 0
      };
    } catch (error) {
      return null;
    }
  }

  // 1. The win moment.
  //
  // `step` is what the session remembers (A2, A3). `show` is the win
  // element it shows.
  function crossed(armName, from, to) {
    if (to <= from || armName !== 'A') return null;
    if (from < 3 && to >= 3) return { step: 'A3', show: 'A3' };
    if (from < 2 && to >= 2) return { step: 'A2', show: 'A2' };
    return null;
  }

  // True once the cart's stamps are what the arm's rule gives for this count.
  // Until then the drawer can still show the step before's prices.
  function settled(armName, state) {
    var n = state.n;
    if (armName === 'A') return n >= 3 ? state.stamped30 === n : state.stamped === n;
    return false;
  }

  function shownSteps() {
    try {
      var list = JSON.parse(sessionStorage.getItem(SHOWN_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function remember(step) {
    var list = shownSteps();
    if (list.indexOf(step) === -1) list.push(step);
    try { sessionStorage.setItem(SHOWN_KEY, JSON.stringify(list)); } catch (error) {}
  }

  var lastN = parseInt(html.getAttribute('data-offer-count'), 10);
  if (isNaN(lastN)) lastN = 0;
  var pending = null;
  var winTimer = null;
  // After a back-forward cache restore the first update only sets the count.
  var rebaseline = false;

  function drawer() {
    return document.querySelector('side-cart-drawer');
  }

  // Shows the win for `win` if the drawer is open and has that win drawn.
  // Returns false when it cannot show now; the win is then let go.
  function showWin(win) {
    var element = drawer();
    if (!element || document.visibilityState === 'hidden') return false;
    if (!element.querySelector('.side-cart.is-open')) return false;
    if (!element.querySelector('.offer-cart__arm[data-arm="' + arm() + '"] [data-win="' + win.show + '"]')) return false;
    if (shownSteps().indexOf(win.step) !== -1) return true;
    remember(win.step);
    element.setAttribute('data-offer-win', win.show);
    // Screen readers hear it through the live region next to the drawer
    // (Liquid renders it outside the part the drawer redraws).
    var live = document.querySelector('[data-offer-win-live]');
    var shown = element.querySelector('.offer-cart__arm[data-arm="' + arm() + '"] [data-win="' + win.show + '"]');
    if (live && shown) {
      var parts = shown.querySelectorAll('.offer-cart__win-title, .offer-cart__win-text');
      live.textContent = Array.prototype.map.call(parts, function (part) { return part.textContent.trim(); }).join(' ');
    }
    clearTimeout(winTimer);
    winTimer = setTimeout(function () {
      element.removeAttribute('data-offer-win');
      if (live) live.textContent = '';
    }, WIN_MS);
    return true;
  }

  // One cart change sends `side-cart:updated` several times: first with the
  // new count, then again once the stamping engine has written. The win waits
  // for stamps that match the new count and a saving above 0, so its line
  // shows the step's own saving.
  window.addEventListener('side-cart:updated', function () {
    var state = readState();
    if (!state || !arm()) return;
    if (rebaseline) {
      rebaseline = false;
      pending = null;
      lastN = state.n;
      return;
    }
    if (state.n < lastN) {
      pending = null;
    } else if (state.n > lastN) {
      var win = crossed(arm(), lastN, state.n);
      if (win) pending = { win: win, until: Date.now() + WIN_WAIT };
    }
    lastN = state.n;
    if (!pending) return;
    if (Date.now() > pending.until) {
      pending = null;
      return;
    }
    if (state.saving > 0 && settled(arm(), state)) {
      showWin(pending.win);
      pending = null;
    }
  });

  // A page restored from the back-forward cache may hold an older count. Its
  // first update sets the count again, with no win.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    pending = null;
    rebaseline = true;
    var element = drawer();
    if (element) element.removeAttribute('data-offer-win');
  });

  // 2. The cart page. Its own ajax refresh runs on the theme's cart events,
  // which the stamping engine does not send. Follow the drawer instead, only
  // for a visitor with an arm, and only when the cart really changed (a
  // return to the tab sends the same cart again).
  var cartPageTimer = null;
  var cartPageSeen = '';
  function signature(cart) {
    if (!cart || !cart.items) return '';
    return cart.total_price + '|' + cart.items.map(function (item) {
      return item.key + ':' + item.quantity + ':' + item.final_line_price;
    }).join(',');
  }
  window.addEventListener('side-cart:updated', function (event) {
    if (!arm()) return;
    var form = document.querySelector('cart-form[data-ajax-update]');
    if (!form || typeof form.refresh !== 'function') return;
    var seen = signature(event.detail && event.detail.cart);
    if (seen && seen === cartPageSeen) return;
    cartPageSeen = seen;
    clearTimeout(cartPageTimer);
    cartPageTimer = setTimeout(function () { form.refresh(); }, 300);
  });

  window.omdOfferCart = { crossed: crossed, settled: settled };
})();
